import React, { useState, useRef, useEffect } from 'react';
import './CustomDropdown.scss';
import arrow from "../../assets/arrow-black.svg"
const CustomDropdown = ({ items = [], onSelect, selected, setSelected, showSortText = true, width }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleSelect = (item) => {
        setSelected(item);
        onSelect?.(item);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="CustomDropdown" ref={dropdownRef} style={{ width: width ? width : "" }}>
            <div className="CustomDropdown-toggle" onClick={toggleDropdown}>
                {showSortText && "Sort by:"}  {selected.label}
                <img className={`arrow-CustomDropdown-toggle ${isOpen ? "isOpen" : ""}`} alt='' src={arrow} />
            </div>
            {isOpen && (
                <div className="CustomDropdown-menu">
                    {items.map((item, idx) => (
                        <div key={idx} className="CustomDropdown-item" onClick={() => handleSelect(item)}>
                            {item.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomDropdown;
